import { FEATURE_TYPE, SELECTOR, setSelector } from '@socialive/common';

const enabled = {
  [FEATURE_TYPE.ACCOUNT]: true,
  [FEATURE_TYPE.APP]: true,
};

const selectFeatureTypes = () => enabled;

setSelector(SELECTOR.FEATURE_TYPES, selectFeatureTypes);

export default selectFeatureTypes;
